import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Timer;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import partial from 'lodash/partial';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconClockLine, IconClockSolid, IconArrowOpenStartLine } from '@instructure/ui-icons';
import * as platform from 'platform';
import { Button } from '@instructure/ui-buttons';
import { TopNavBar } from '@instructure/ui-top-nav-bar';
import { View } from '@instructure/ui-view';
import { jsx } from '@instructure/emotion';
import FormattedDuration from '../../../shared/FormattedDuration';
import { formatTime } from '../../../../util/formatTimespan';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
export var Timer = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Timer = /*#__PURE__*/function (_Component) {
  function Timer() {
    var _this2;
    _classCallCheck(this, Timer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Timer, [].concat(args));
    _defineProperty(_this2, "handleKeyDown", function (event) {
      // Check for Alt+Shift+T and nothing else
      if (event.keyCode === 84 && event.altKey && event.shiftKey && !event.ctrlKey) {
        var message;
        event.preventDefault();
        if (_this2.props.timeLeftInSeconds >= 1) {
          var timeString = formatTime(_this2.props.timeLeftInSeconds);
          message = t('The remaining time is: {timeleft}', {
            timeleft: timeString
          });
        } else {
          message = t('There is no remaining time left');
        }
        _this2.props.screenreaderNotification(message);
      }
    });
    _defineProperty(_this2, "showTimerRef", function (node) {
      _this2.showTimerBtn = node;
    });
    _defineProperty(_this2, "hideTimerRef", function (node) {
      _this2.hideTimerBtn = node;
    });
    _defineProperty(_this2, "focusOnShow", function () {
      _this2.showTimerBtn && _this2.showTimerBtn.focus();
    });
    _defineProperty(_this2, "focusOnHide", function () {
      _this2.hideTimerBtn && _this2.hideTimerBtn.focus();
    });
    return _this2;
  }
  _inherits(Timer, _Component);
  return _createClass(Timer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
        timerMinimized = _this$props.timerMinimized,
        screenreaderNotification = _this$props.screenreaderNotification,
        timerRunning = _this$props.timerRunning,
        showTimer = _this$props.showTimer;
      if (timerMinimized !== prevProps.timerMinimized) {
        var message = timerMinimized ? t('timer minimized') : t('timer showing');
        screenreaderNotification(message);
        var focusFn = timerMinimized ? this.focusOnShow : this.focusOnHide;
        focusFn();
      }
      if (timerRunning && !prevProps.timerRunning) {
        document.body.addEventListener('keydown', this.handleKeyDown);
      } else if (!timerRunning && prevProps.timerRunning) {
        document.body.removeEventListener('keydown', this.handleKeyDown);
      }
      this.props.setTimerEnabled(showTimer && timerRunning);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "renderHelpScreenreaderText",
    value: function renderHelpScreenreaderText() {
      // command based on operating system
      var shortcutKey = platform.os.toString().startsWith('OS X') ? t('Option+Shift+T') : t('Alt+Shift+T');
      return jsx(ScreenReaderContent, null, t('During the quiz, press {shortcutKey} to have the remaining time read', {
        shortcutKey: shortcutKey
      }));
    }
  }, {
    key: "renderMinimizedTimer",
    value: function renderMinimizedTimer() {
      if (this.props.iceTopNavBarEnabled) {
        return jsx(TopNavBar.Item, {
          id: "TimerButton",
          onClick: partial(this.props.updateTimerMinimized, false),
          variant: "icon",
          renderIcon: jsx(IconClockLine, null),
          tooltip: t('Show Timer'),
          "aria-expanded": "false",
          itemRef: this.showTimerRef
        }, t('Show Timer'));
      }
      return jsx("div", {
        css: this.props.styles.timer
      }, this.renderHelpScreenreaderText(), jsx(Button, {
        "aria-expanded": "false",
        ref: this.showTimerRef,
        renderIcon: IconClockLine,
        onClick: partial(this.props.updateTimerMinimized, false)
      }, jsx(ScreenReaderContent, null, t('Show Timer'))));
    }
  }, {
    key: "renderMaximizedTimer",
    value: function renderMaximizedTimer() {
      if (this.props.iceTopNavBarEnabled) {
        return jsx(TopNavBar.Item, {
          id: "TimerButton",
          onClick: partial(this.props.updateTimerMinimized, true),
          variant: "forceIconWithLabel",
          renderIcon: jsx(IconClockSolid, null),
          tooltip: t('Hide Timer'),
          "aria-expanded": "true",
          itemRef: this.hideTimerRef
        }, jsx(FormattedDuration, {
          seconds: this.props.timeLeftInSeconds
        }));
      }
      return jsx("div", {
        css: this.props.styles.timer
      }, this.renderHelpScreenreaderText(), jsx(View, {
        as: "div"
      }, jsx("div", {
        css: this.props.styles.timerLeft
      }, jsx("div", {
        css: this.props.styles.timeRemainingLabel
      }, t('Time Remaining')), jsx(FormattedDuration, {
        seconds: this.props.timeLeftInSeconds
      }))), jsx("div", {
        css: this.props.styles.timerRight
      }, jsx(Button, {
        "aria-expanded": "true",
        ref: this.hideTimerRef,
        renderIcon: IconArrowOpenStartLine,
        onClick: partial(this.props.updateTimerMinimized, true)
      }, jsx(ScreenReaderContent, null, t('Hide Timer')))));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.timerRunning || !this.props.showTimer) {
        return null;
      } else if (this.props.timerMinimized) {
        return this.renderMinimizedTimer();
      } else {
        return this.renderMaximizedTimer();
      }
    }
  }]);
}(Component), _defineProperty(_Timer, "displayName", 'Timer'), _defineProperty(_Timer, "componentId", "Quizzes".concat(_Timer.displayName)), _defineProperty(_Timer, "propTypes", {
  screenreaderNotification: PropTypes.func.isRequired,
  showTimer: PropTypes.bool.isRequired,
  timeLeftInSeconds: PropTypes.number,
  timerMinimized: PropTypes.bool,
  timerRunning: PropTypes.bool,
  updateTimerMinimized: PropTypes.func.isRequired,
  iceTopNavBarEnabled: PropTypes.bool,
  setTimerEnabled: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_Timer, "defaultProps", {
  timerRunning: false,
  timeLeftInSeconds: 0,
  timerMinimized: false,
  iceTopNavBarEnabled: false,
  setTimerEnabled: function setTimerEnabled() {}
}), _Timer)) || _class);
export default Timer;